import { useEffect } from 'react';
import { supabase } from '@/lib/supabase/client';
import { useAuthStore } from '@/stores/authStore';
import { usePresenceStore } from '@/stores/presenceStore';

export function usePresence() {
  const profile = useAuthStore((s) => s.profile);
  const setOnlineIds = usePresenceStore((s) => s.setOnlineIds);

  useEffect(() => {
    if (!profile) return;

    const channel = supabase.channel('online-users')
      .on('presence', { event: 'sync' }, () => {
        const state = channel.presenceState<{ profile_id: string }>();
        const ids = new Set(
          Object.values(state).flat().map((p) => p.profile_id),
        );
        setOnlineIds(ids);
      })
      .subscribe(async (status) => {
        if (status === 'SUBSCRIBED') {
          await channel.track({ profile_id: profile.id });
        }
      });

    return () => {
      void channel.untrack().finally(() => supabase.removeChannel(channel));
    };
  }, [profile?.id, setOnlineIds]);
}
